module.exports = __webpack_public_path__ + "static/media/slot-animated-header.b4ecd05f.png";